<template>
  <div class="rzy-page">
    <div class="rzy-top-bar">
      <el-button
        v-if="$store.state.role.role.includes('outwareorder.create')"
        type="primary"
        @click="Add()"
        style=""
        icon="el-icon-circle-plus"
        >新增</el-button
      >
      <el-button
        type="success"
        @click="checkDialogOpend(1)"
        icon="el-icon-check"
        >审核通过</el-button
      >
      <el-button type="danger" @click="checkDialogOpend(2)" icon="el-icon-close"
        >审核不通过</el-button
      >
      <el-button
        v-if="$store.state.role.role.includes('outwareorder.delete')"
        type="primary"
        @click="delDialogOpend()"
        style=""
        icon="el-icon-remove"
        >删除</el-button
      >

      <el-button
        type="primary"
        @click="initPrint('localListTableId')"
        icon="el-icon-printer"
        >打印</el-button
      >

      <div style="margin-left: 3%; display: flex; flex-direction: row; ">
        <div style="width: 20%;line-height: 40px;">出库日期</div>
        <el-date-picker
          style=""
          @change="daterangeSelectChange()"
          v-model="daterangeSelectResult"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
    </div>

    <el-table
      :data="responseData"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ padding: '0px' }"
      border
      stripe
      id="localListTableId"
      @selection-change="handleSelectionChange"
      v-loading="loading"
    >
      <!-- 选择多行数据时使用 Checkbox。 -->
      <el-table-column type="selection" width="40" align="center">
      </el-table-column>

      <el-table-column
        label="行"
        type="index"
        :index="indexMethod"
        align="center"
      >
      </el-table-column>

      <el-table-column
        sortable
        prop="createTime"
        label="单据日期"
        align="center"
      >
      </el-table-column>
      <el-table-column sortable prop="number" label="单据编号" align="center">
        <template slot-scope="scope">
          <el-link type="primary" @click="goToDetails(scope.row.id)">
            {{ scope.row.number }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="isCheck_change"
        label="审核状态"
        align="center"
      >
      </el-table-column>
      <el-table-column sortable prop="customer" label="客户名称" align="center">
      </el-table-column>

      <el-table-column
        sortable
        prop="outWarehouse"
        label="出库仓库"
        align="center"
      >
      </el-table-column>
      <el-table-column sortable prop="contact" label="出库员" align="center">
      </el-table-column>
      <el-table-column
        sortable
        prop="warehousingQuantity"
        label="出库数量"
        align="center"
      >
      </el-table-column>

      <el-table-column sortable prop="remark" label="备注" align="center">
      </el-table-column>
    </el-table>

    <el-pagination
      style="text-align: center"
      background
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pageInfo.size"
      :current-page="pageInfo.page"
      :page-count="totalPages"
    >
    </el-pagination>

    <!-- 审核 对话框 -->
    <el-dialog
      title="审核"
      :visible.sync="checkDialogVisible"
      width="50%"
      @close="checkDialogClosed"
    >
      <el-form ref="checkFormRef" label-width="" :model="checkForm">
        <el-form-item :label="checkRequestTitle"> </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="checkWarehouse">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除 对话框 -->
    <!-- <del-confirm ref="delConfirm" @update="getList(pageInfo.page)" /> -->
    <el-dialog
      title="删除仓库"
      :visible.sync="delDialogVisible"
      width="50%"
      @close="delDialogClosed"
    >
      <el-form ref="delFormRef" label-width="" :model="delForm">
        <el-form-item label="确定删除?"> </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="delWarehouse">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //分页 -- sta
      pageInfo: {
        page: 1,
        size: 15,
      },
      totalPages: 0,
      //分页 -- end
      loading: false,

      //日期范围选择控件 -- sta
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      daterangeSelectResult: "", //日期范围 选择的结果
      //日期范围选择控件 -- end

      responseData: [
        // 调试用假数据--正式版注释掉
        // {
        //     date: 'XXX',
        //     number: 'XXX',
        //     isCheck_change: 'XXX',
        //     provider: 'XXX',
        //     outWarehouse: 'XXX',
        //     contact: 'XXX',
        //     warehousingQuantity: 'XXX',
        //     remark: 'XXX',
        // }
      ],

      multipleSelection: [], //列表选中多行。
      m_ids: "", //POST 参数
      checkDialogVisible: false, //启用 对话框
      delDialogVisible: false, //删除 对话框

      checkRequest: 0, //审核请求: 0=不通过, 1=通过。
      checkRequestTitle: "", //对话框显示的提示。
    };
  },
  methods: {
    // 在打印当前报表前，拼接title
    initPrint(id) {
      this.utils.printTable(id, `出库单列表`);
    },

    // 分页切换
    handleCurrentChange(newNum) {
      this.getPeiBuList(newNum);
    },

    // 日期范围选择控件，内容改变事件
    daterangeSelectChange() {
      // console.log('daterangeSelectResult=', this.daterangeSelectResult)
      // console.log('daterangeSelectResult[0]=', this.daterangeSelectResult[0])
      // console.log('daterangeSelectResult[1]=', this.daterangeSelectResult[1])

      //开始时间 转 时间戳
      let m_date = new Date(this.daterangeSelectResult[0]);
      let m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
      this.pageInfo.startTime = m_time;
      // console.log('startTime=', this.pageInfo.startTime)

      //结束时间 转 时间戳
      m_date = new Date(this.daterangeSelectResult[1]);
      m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
      this.pageInfo.endTime = m_time;
      // console.log('endTime=', this.pageInfo.endTime)

      this.refreshPage();
    },

    // 刷新
    refreshPage() {
      this.getList(1);
      this.$Message.success("刷新成功");
    },

    // 条件查询
    queryBySelect(pageInfo) {
      this.pageInfo = pageInfo;
      this.getList(1);
    },
    // 清空条件查询
    clearQuery(pageInfo) {
      this.pageInfo = pageInfo;
      this.getList(1);
    },

    // 获取XX分页列表
    getList(val) {
      this.pageInfo.page = val;
      this.loading = true;
      this.$requestBase({
        url: "v1/outbound/list",
        method: "get",
        params: this.pageInfo,
      })
        .then((res) => {
          this.responseData = this.formatResponse(res.data.list);
          this.totalPages = res.data.pages;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 格式化XX列表
    formatResponse(response) {
      response.forEach((item, index) => {
        //hcy: 前端 要判断 isDeleted ，=0 才显示 出来。
        if (item.isDeleted != 0) {
          return; //通过return跳过当次循环
        }

        item.createTime = this.utils.timestampToTime(item.createTime, 2);

        if (item.isCheck === 2) {
          item.isCheck_change = "审核不通过";
        } else if (item.isCheck === 1) {
          item.isCheck_change = "审核通过";
        } else {
          item.isCheck_change = "未审";
        }
      });
      return response;
    },

    //新增
    Add() {
      this.$router.push({
        path: `outWarehouseAdd2`,
        query: {
          type: 0, //0=新建, 1=编辑.
          // wuLiaoId: XXX, 不需要
        },
      });
    },
    // 路由至XX详情
    goToDetails(id) {
      this.$router.push(`outWarehouseDetalis2/${id}`);
    },

    //列表中 选中多行。
    handleSelectionChange(val) {
      // console.log("val=", val)
      this.multipleSelection = val;
    },

    //审核 ------------------------------sta
    // 显示 审核对话框
    // hcy: check=0是未审核，1是审核通过，2是未通过。
    checkDialogOpend(checkRequest) {
      if (0 === this.multipleSelection.length) {
        this.$Message.success("请使用勾选框选择");
      } else {
        this.checkDialogVisible = true;
        this.checkRequest = checkRequest;
        if (checkRequest === 2) {
          this.checkRequestTitle = "确定审核不通过？";
        } else {
          this.checkRequestTitle = "确定审核通过？";
        }
      }
    },
    // 监听 审核对话框 的关闭事件
    checkDialogClosed() {
      this.$refs.checkFormRef.resetFields();
    },
    //审核
    checkWarehouse() {
      this.m_ids = ""; //初始化
      for (let i = 0; i < this.multipleSelection.length; i++) {
        if ("" === this.m_ids) {
          //第一个直接赋值
          this.m_ids = this.multipleSelection[i].id;
          // console.log('this.m_ids=',this.m_ids)
        } else {
          this.m_ids = this.m_ids + "," + this.multipleSelection[i].id;
          // console.log('this.m_ids=',this.m_ids)
        }
      }

      this.$requestBase({
        url:
          "v1/outbound/check?ids=" + this.m_ids + "&check=" + this.checkRequest,
        method: "POST",
        data: {
          //hcy: 参数要放在url中
          // ids: this.m_ids,
          // check: 1, //0=不通过? 1=通过?
        },
      }).then((res) => {
        this.getList(1);
        this.$Message.success("审核成功");

        this.checkDialogVisible = false;
      });
    },
    //审核 ---------------------------------end

    //删除 ---------------------------------sta
    // 显示 删除对话框
    delDialogOpend() {
      if (0 === this.multipleSelection.length) {
        this.$Message.success("请使用勾选框选择");
      } else {
        this.delDialogVisible = true;
      }
    },
    // 监听 删除对话框 的关闭事件
    delDialogClosed() {
      this.$refs.delFormRef.resetFields();
    },
    //删除 出库单
    //hcy: 部署了新版本，添加了check=0,1,2三种状态，check=0,2下可以删除单子，check=1状态下会提示错误。
    delWarehouse() {
      this.m_ids = ""; //初始化
      for (let i = 0; i < this.multipleSelection.length; i++) {
        if ("" === this.m_ids) {
          //第一个直接赋值
          this.m_ids = this.multipleSelection[i].id;
          // console.log('this.m_ids=',this.m_ids)
        } else {
          this.m_ids = this.m_ids + "," + this.multipleSelection[i].id;
          // console.log('this.m_ids=',this.m_ids)
        }
      }

      this.$requestBase({
        url: "v1/outbound/delete?ids=" + this.m_ids,
        method: "POST",
        data: {
          // ids: this.m_ids,     //hcy: 参数要放在url中
        },
      }).then((res) => {
        this.getList(1);
        this.$Message.success("删除成功");

        this.delDialogVisible = false;
      });
    },
    //删除 ---------------------------------end

    //给 所有 表格 自动 加行号
    indexMethod(index) {
      return index + 1;
    },
  },
  mounted() {
    this.getList(1);
  },
  activated() {
    this.getList(1);
  },
};
</script>

<style scoped lang="scss"></style>
